import { flowRight as compose } from 'lodash';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';
import withUser from '~lib/common/hoc/withUser';

import CaseScenario from './CaseScenario.vue';
import avatarQueries from '~lib/common/queries/Avatar';
import environmentQueries from '~lib/common/queries/Environment';
import voiceQueries from '~lib/common/queries/Voice';

const enhance = compose(
  dataView({ queries: avatarQueries }),
  renameProps({ data: 'avatars' }),
  dataView({ queries: environmentQueries }),
  renameProps({ data: 'environments' }),
  dataView({ queries: voiceQueries }),
  renameProps({ data: 'voices' }),
);

export default withUser()(enhance(CaseScenario));
